export { default } from './GameSpaceInvader'
